import { css } from '@inter-ikea-kompis/web-component';
import { Table, Text } from '@ingka/common-styles-webc';
export default class TechnicalInformationCardStyle {
    /**
     * @param options Options object.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const space100 = options.theme.spacing.space100;
        return css `
			${Text.CSS}
			${Table.CSS}

			.header {
				display: flex;
				margin-bottom: ${space100 / 16}rem;
			}

			.productDescription {
				display: flex;
				flex-direction: column;
			}

			/* TODO vertical-align is overriding user agent stylesheet, Skapa doesn't expose this yet. */
			td {
				vertical-align: top;
			}
		`;
    }
}
//# sourceMappingURL=TechnicalInformationCardStyle.js.map